"use client";

import { type ReactNode } from "react";
import { AnimatePresence, m } from "motion/react";
import { usePathname } from "next/navigation";

export default function RouteTransition({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <m.div
        key={pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.18, ease: "easeOut" } }}
        exit={{ opacity: 0, transition: { duration: 0.12, ease: "easeIn" } }}
      >
        {children}
      </m.div>
    </AnimatePresence>
  );
}
